// extracted by mini-css-extract-plugin
export var actionText = "_mw-4";
export var container = "_mw-0";
export var leftSection = "_mw-1";
export var rightSection = "_mw-2";
export var settingsButton = "_mw-6";
export var settingsIcon = "_mw-7";
export var shortcut = "_mw-5";
export var shortcutGroup = "_mw-3";